<template>
    <div v-if="Object.keys(order).length > 0" class="row">
        <!-- Sticky Navigation -->
        <div class="col-12 sticky-top" style="z-index: 1000; top: 55px;">
            <div class="card border-0 shadow-sm rounded-4 mb-2">
                <div class="card-body p-2">
                    <ul class="nav nav-pills nav-fill gap-1 small fw-bold flex-nowrap overflow-auto" style="scrollbar-width: none;">
                        <li class="nav-item">
                            <a class="nav-link bg-light text-dark cursor-pointer rounded-3" @click.prevent="scrollToSection('general-info')">General</a>
                        </li>
                        <li class="nav-item">
                             <a class="nav-link bg-light text-dark cursor-pointer rounded-3" @click.prevent="scrollToSection('order-actions')">Comments</a>
                        </li>
                         <li class="nav-item">
                             <a class="nav-link bg-light text-dark cursor-pointer rounded-3" @click.prevent="scrollToSection('upload-images')">Upload</a>
                        </li>
                         <li class="nav-item">
                             <a class="nav-link bg-light text-dark cursor-pointer rounded-3" @click.prevent="scrollToSection('order-history')">History</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <div class="col-12" id="general-info">
            <!--Display general information-->
            <div class="card rounded-4">
                <div class="card-header py-2 d-flex justify-content-between align-items-center rounded-top-4">
                    <div>General Information</div>
                    <a href="/handyman/orders" class="text-theme cursor-pointer"><i class="bi bi-arrow-left pe-1"></i> Back</a>
                </div>
                <div class="card-body">
                    <!-- Design one  -->
                    <div class="profile-overview d-none">
                        <div class="row">
                            <div class="col-lg-3 col-md-4 label">Customer</div>
                            <div class="col-lg-9 col-md-8">{{ order.customer_full_name }}</div>
                        </div>
                        <template v-if="order.customer_account_type === 'business'">
                            <div class="row">
                                <div class="col-lg-3 col-md-4 label">Agency Contact Number</div>
                                <div class="col-lg-9 col-md-8">
                                    {{ order.customer_phone_number }}
                                    <span @click="copyToClipboard(order.customer_phone_number)" class="cursor-pointer">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-clipboard"><rect width="8" height="4" x="8" y="2" rx="1" ry="1"/><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/></svg>
                                    </span>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-3 col-md-4 label">Customer Contact Number</div>
                                <div class="col-lg-9 col-md-8">
                                    {{ order.contact_person_phone_number }}
                                    <span @click="copyToClipboard(order.contact_person_phone_number)" class="cursor-pointer">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-clipboard"><rect width="8" height="4" x="8" y="2" rx="1" ry="1"/><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/></svg>
                                    </span>
                                </div>
                            </div>
                        </template>
                        <template v-else>
                            <div class="row">
                                <div class="col-lg-3 col-md-4 label">Customer Contact Number</div>
                                <div class="col-lg-9 col-md-8">
                                    {{ order.customer_phone_number }}
                                    <span @click="copyToClipboard(order.customer_phone_number)" class="cursor-pointer">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-clipboard"><rect width="8" height="4" x="8" y="2" rx="1" ry="1"/><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/></svg>
                                    </span>
                                </div>
                            </div>
                        </template>
                        <div class="row">
                            <div class="col-lg-3 col-md-4 label">Order Address</div>
                            <div class="col-lg-9 col-md-8">
                                {{ order.address.full_address }}
                                <span @click="copyToClipboard(order.address.full_address)" class="cursor-pointer">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-clipboard"><rect width="8" height="4" x="8" y="2" rx="1" ry="1"/><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/></svg>
                                </span>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-3 col-md-4 label">Service Date & Time</div>
                            <div class="col-lg-9 col-md-8">{{ dataTimeFormatWithoutUTC(order.booking_date, 'DD-MMM-YYYY, hh:mm A') }}</div>
                        </div>
                        <div class="row">
                            <div class="col-lg-3 col-md-4 label">Order Priority</div>
                            <div class="col-lg-9 col-md-8">{{ order.priority }}</div>
                        </div>
                        <div class="row">
                            <div class="col-lg-3 col-md-4 label">Services</div>
                            <div class="col-lg-9 col-md-8">
                                {{ order?.order_items?.map(item => item?.service_name).join(', ')}}
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-3 col-md-4 label">Access Arrangement</div>
                            <div class="col-lg-9 col-md-8">
                                {{ order?.access_arrangement }}
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-3 col-md-4 label">Comment</div>
                            <div class="col-lg-9 col-md-8">
                                <!-- Filter the comment from the order history for action_type=='order_created' -->
                                {{ order?.order_histories.filter(item => item?.action_type === 'order_created').map(item => item?.comment).join(', ') }}
                            </div>
                        </div>
                        <!-- Check if special_note is not empty -->
                        <div class="row" v-if="order?.special_note">
                            <div class="col-lg-3 col-md-4 label">Special Note</div>
                            <div class="col-lg-9 col-md-8">
                                {{ order?.special_note }}
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-3 col-md-4 label">Task Status</div>
                            <div class="col-lg-9 col-md-8">
                                <button
                                    type="button"
                                    class="btn btn-theme btn-sm w-100"
                                    :class="{'disabled': isOrderCompleted}"
                                    :disabled="isOrderCompleted"
                                    @click="updateTaskStatus"
                                >{{ isOrderCompleted ? 'Completed' : 'Mark as completed' }}</button>
                            </div>
                        </div>
                    </div>

                    <!-- Design two -->
                    <div class="profile-overview">
                        <div class="row mb-2">
                            <div class="col-4 col-lg-3 col-md-4 label">Customer</div>
                            <div class="col-8 col-lg-9 col-md-8">{{ order.customer_full_name }}</div>
                        </div>
                        <template v-if="order.customer_account_type === 'business'">
                            <div class="row mb-2">
                                <div class="col-4 col-lg-3 col-md-4 label">Agency No.</div>
                                <div class="col-8 col-lg-9 col-md-8">
                                    {{ order.customer_phone_number }}
                                    <span @click="copyToClipboard(order.customer_phone_number)" class="cursor-pointer">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#464f82" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-copy-icon lucide-copy"><rect width="14" height="14" x="8" y="8" rx="2" ry="2"/><path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"/></svg>
                                    </span>
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-4 col-lg-3 col-md-4 label">Mobile</div>
                                <div class="col-8 col-lg-9 col-md-8">
                                    {{ order.contact_person_phone_number }}
                                    <span @click="copyToClipboard(order.contact_person_phone_number)" class="cursor-pointer">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#464f82" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-copy-icon lucide-copy"><rect width="14" height="14" x="8" y="8" rx="2" ry="2"/><path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"/></svg>
                                    </span>
                                </div>
                            </div>
                        </template>
                        <template v-else>
                            <div class="row mb-2">
                                <div class="col-4 col-lg-3 col-md-4 label">Mobile</div>
                                <div class="col-8 col-lg-9 col-md-8">
                                    {{ order.customer_phone_number }}
                                    <span @click="copyToClipboard(order.customer_phone_number)" class="cursor-pointer">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#464f82" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-copy-icon lucide-copy"><rect width="14" height="14" x="8" y="8" rx="2" ry="2"/><path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"/></svg>
                                    </span>
                                </div>
                            </div>
                        </template>
                        <div class="row mb-2">
                            <div class="col-4 col-lg-3 col-md-4 label">Address</div>
                            <div class="col-8 col-lg-9 col-md-8">
                                {{ order.address.full_address }}
                                <span @click="copyToClipboard(order.address.full_address)" class="cursor-pointer">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#464f82" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-copy-icon lucide-copy"><rect width="14" height="14" x="8" y="8" rx="2" ry="2"/><path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"/></svg>
                                </span>
                            </div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-4 col-lg-3 col-md-4 label">Date & Time</div>
                            <div class="col-8 col-lg-9 col-md-8">{{ dataTimeFormatWithoutUTC(order.booking_date, 'DD-MMM-YYYY, hh:mm A') }}</div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-4 col-lg-3 col-md-4 label">Priority</div>
                            <div class="col-8 col-lg-9 col-md-8">{{ order.priority }}</div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-4 col-lg-3 col-md-4 label">Services</div>
                            <div class="col-8 col-lg-9 col-md-8">
                                {{ order?.order_items?.map(item => item?.service_name).join(', ')}}
                            </div>
                        </div>
                        <div v-if="order?.access_arrangement" class="row mb-2">
                            <div class="col-4 col-lg-3 col-md-4 label">Access Arrangement</div>
                            <div class="col-8 col-lg-9 col-md-8">
                                {{ order?.access_arrangement }}
                            </div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-4 col-lg-3 col-md-4 label">Comment</div>
                            <div class="col-8 col-lg-9 col-md-8">
                                <!-- Filter the comment from the order history for action_type=='order_created' -->
                                {{ order?.order_histories.filter(item => item?.action_type === 'order_created').map(item => item?.comment).join(', ') }}
                            </div>
                        </div>
                        <!-- Check if special_note is not empty -->
                        <div v-if="order?.special_note" class="row mb-2">
                            <div class="col-4 col-lg-3 col-md-4 label">Special Note</div>
                            <div class="col-8 col-lg-9 col-md-8">
                                {{ order?.special_note }}
                            </div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-12 text-center">
                                <button
                                    type="button"
                                    class="btn btn-theme btn-sm w-100"
                                    :class="{'disabled': isOrderCompleted}"
                                    :disabled="isOrderCompleted"
                                    @click="updateTaskStatus"
                                >{{ isOrderCompleted ? 'Completed' : 'Mark as completed' }}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!--Display order details-->
            <!--<div class="card">
                <div class="card-header py-2">Order Details</div>
                <div class="card-body table-responsive">
                    <table class="table table-bordered">
                        <thead>
                            <tr>
                                <th>Service</th>
                                <th class="text-center">Item Cost</th>
                                <th class="text-center">Labour Cost</th>
                                <th class="text-center">Discount(%)</th>
                                <th class="text-center">Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in order.order_items" :key="item.id">
                                <td>{{ item.service_name }}</td>
                                <td class="text-center">{{currencySymbol}}{{ item.order_item_price }}</td>
                                <td class="text-center">{{currencySymbol}}{{ item.order_item_labour_cost }}</td>
                                <td class="text-center">{{ item.order_item_discount_value }}</td>
                                <td class="text-center">{{currencySymbol}}{{ item.order_item_total_amount }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>-->
        </div>
        <div class="col-md-12" id="order-actions">
            <div class="card rounded-4">
                <div class="card-header py-2 rounded-top-4">Order actions</div>
                <div class="card-body">
                    <div class="row g-3">
                        <div class="col-md-12">
                            <label for="comment" class="form-label">Comment</label>
                            <textarea class="form-control" id="comment" rows="3" placeholder="Enter comment" v-model="updateOrderData.comment"></textarea>
                        </div>
                        <div class="col-12">
                            <button
                                type="button"
                                class="btn btn-theme btn-sm float-end"
                                :class="{'disabled': processing || (updateOrderData.comment === '' && Object.keys(updateOrderData.files).length === 0) }"
                                :disabled="processing || (updateOrderData.comment === '' && Object.keys(updateOrderData.files).length === 0)"
                                @click="updateOrder"
                            >{{ processing ? 'Processing...' : 'Submit' }}</button>
                        </div>
                        <!-- <div class="col-md-12">
                            <label for="description" class="form-label">Attachment</label>
                            <div class="input-group mb-3">
                                <input
                                    type="file"
                                    class="form-control"
                                    id="orderImage"
                                    multiple
                                    @change="onFileChange"
                                />
                            </div>
                            <img
                                v-for="(previewImage, index) in previewOrderImages"
                                :src="prepareImageSource(previewImage)"
                                :key="index"
                                class="img-thumbnail me-2 mb-2"
                                :style="{'max-height': 150 + 'px', 'max-width': 150 + 'px'}"
                            />
                        </div>
                        <div class="col-12">
                            <button
                                type="button"
                                class="btn btn-theme float-end"
                                :class="{'disabled': processing || (updateOrderData.comment === '' && Object.keys(updateOrderData.files).length === 0) }"
                                :disabled="processing || (updateOrderData.comment === '' && Object.keys(updateOrderData.files).length === 0)"
                                @click="updateOrder"
                            >{{ processing ? 'Processing...' : 'Submit' }}</button>
                        </div> -->
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-12" id="upload-images">
            <div class="card rounded-4">
                <div class="card-header py-2 rounded-top-4">Upload Images</div>
                <div class="card-body">
                    <div class="row g-3">
                        <div class="col-md-12">
                            <ImageUploader :orderId="order.id" @uploads-completed="handleUploadsCompleted"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--<div class="col-md-6">
            <div class="card rounded-4">
                <div class="card-header py-2 rounded-top-4">Payment Details</div>
                <div class="card-body profile-overview">
                    <div class="row">
                        <div class="col-lg-3 col-md-4 label">Total Amount</div>
                        <div class="col-lg-9 col-md-8">{{currencySymbol}}{{ order.total_price }}</div>
                    </div>
                    <div v-if="order.discount_value > 0" class="row">
                        <div class="col-lg-3 col-md-4 label">Discount</div>
                        <div class="col-lg-9 col-md-8">{{ order.discount_value }}%</div>
                    </div>
                    <div v-if="order.discount_value > 0" class="row">
                        <div class="col-lg-3 col-md-4 label">Discount</div>
                        <div class="col-lg-9 col-md-8">{{currencySymbol}}{{ order.discount_value }}</div>
                    </div>
                    <div class="row">
                        <div class="col-lg-3 col-md-4 label">VAT</div>
                        <div class="col-lg-9 col-md-8">{{ order.tax }}%</div>
                    </div>
                    <div class="row">
                        <div class="col-lg-3 col-md-4 label">VAT Amount</div>
                        <div class="col-lg-9 col-md-8">{{currencySymbol}}{{ order.tax_amount }}</div>
                    </div>
                    <div class="row">
                        <div class="col-lg-3 col-md-4 label">Final Amount</div>
                        <div class="col-lg-9 col-md-8">{{currencySymbol}}{{ order.final_amount }}</div>
                    </div>
                </div>
            </div>
        </div>-->
    </div>

    <!-- Order Timeline -->
    <div id="order-history">
        <OrderActivity :order="order" />
    </div>

    <!-- Mark order completed modal popup -->
    <div class="modal fade" id="markOrderCompletedModal" tabindex="-1" aria-labelledby="markOrderCompletedModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <Form :validation-schema="markCompletedSchema" v-slot="{ handleSubmit, errors }" as="div">
                    <div class="modal-header">
                        <h5 class="modal-title" id="markOrderCompletedModalLabel">Mark Order Completed</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <div class="mb-3">
                            <label for="revisitOrComplete" class="form-label">Select Status</label>
                            <Field
                                as="select"
                                name="revisitOrComplete"
                                class="form-select"
                                :class="{ 'is-invalid':errors.revisitOrComplete }"
                                v-model="completedOrder.revisitOrComplete"
                            >
                                <option value="">Select</option>
                                <option value="revisit_required">Revisit Required</option>
                                <option value="complete">Complete</option>
                            </Field>
                            <div class="is-invalid invalid-feedback">{{  errors.revisitOrComplete  }}</div>
                        </div>
                        <div class="mb-3">
                            <label for="reasonInput" class="form-label">Comment</label>
                            <Field
                                as="textarea"
                                id="reasonInput"
                                name="comment"
                                class="form-control bg-white"
                                rows="3"
                                placeholder="Enter note"
                                v-model="completedOrder.comment"
                                :class="{ 'is-invalid':errors.comment }"
                            ></Field>
                            <div class="is-invalid invalid-feedback">{{  errors.comment  }}</div>
                        </div>
                        <div class="mb-3">
                            <label for="reasonInput" class="form-label">Upload Images</label>
                            <Field
                                as="input"
                                type="file"
                                name="orderImage"
                                id="orderImage"
                                class="form-control"
                                :class="{ 'is-invalid':errors.orderImage }"
                                multiple
                                accept="image/*"
                                @change="selectTaskImage"
                            />
                            <div class="is-invalid invalid-feedback">{{  errors.comment  }}</div>
                        </div>
                        <!-- Display image preview -->
                        <div v-if="completedOrder.images.length > 0" class="mb-3">
                            <img
                                v-for="(item, index) in completedOrder.images"
                                :src="prepareImageSource(item)"
                                :key="index"
                                class="img-thumbnail me-2 mb-2"
                                :style="{'max-height': 100 + 'px', 'max-width': 100 + 'px'}"
                            />
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-sm btn-secondary" data-bs-dismiss="modal">Cancel</button>
                        <button
                            type="button"
                            class="btn btn-sm btn-theme"
                            :disabled="processing"
                            :class="{'disabled': processing}"
                            v-text="processing ? 'Processing...' : 'Submit'"
                            @click="handleSubmit($event, markCompleted)"
                        ></button>
                    </div>
                </Form>
            </div>
        </div>
    </div>
</template>

<script>
import moment from "moment";
import OrderActivity from "./OrderActivity";
import ImageUploader from './ImageUploader';
import { is } from "@vee-validate/rules";
import { appMixin } from '../mixin/appMixin';

export default {
    name: "HandymanOrderDetail",
    mixins: [appMixin],
    components: {
        OrderActivity,
        ImageUploader
    },
    props: {
        orderDetail: {
            type: Object,
            default: () => {}
        },
        orderNumber: {
            default: ''
        }
    },
    data() {
        return {
            currencySymbol: '£',
            processing: false,
            order: {},
            previewOrderImages: [],
            updateOrderData: {
                orderId: '',
                comment: '',
                files: [],
            },
            isCompleted: false,
            orderStatus: this.orderDetail?.status || '',
            completeOrderComment: '',
            completedOrder: {
                revisitOrComplete: '', // revisit_required or complete
                comment: '',
                files: [],
                images: [] // this only for preview purpose
            }
        }
    },
    created() {
    },
    mounted() {
        this.attachImageSlider();

        this.getOrderDetails();
    },
    computed: {
        user() {
            return this.$store.state.user;
        },
        isOrderCompleted() {
            let status = this.order?.status || '';
            return ['completed', 'cancelled', 'canceled', 'rejected', 'engineer_completed'].includes(status);
        },
        markCompletedSchema() {
            return {
                //completeOrderComment: 'required|min:5',
                revisitOrComplete: 'required',
                comment: 'required',
                //orderImage: 'required'
            }
        }
    },
    methods: {
        getOrderDetails() {
            let self = this;
            axios.post('/handyman/orders/' + this.orderNumber)
                .then((response) => {
                    self.order = response.data.order;
                    self.updateOrderData.orderId = self.order?.id;
                    self.orderStatus = self.order?.status || '';

                    // Check if order_images are exist and then trigger the SimpleSlider
                    if (typeof this.order.order_images !== "undefined" && this.order.order_images.length > 0) {
                        self.attachImageSlider();
                    }
                })
        },
        formatDate(date, format) {
            return moment(date).format(format);
        },
        onFileChange(event) {
            const files = Array.from(event.target.files);
            const batchId = Date.now();
            this.updateOrderData.files = [];
            this.previewOrderImages = [];

            // Show notification
            this.$notification('info', 'Uploading files please wait...');
            this.processing = true;

            // Create upload promises for each file
            const uploadPromises = files.map(file => {
                return new Promise((resolve, reject) => {
                    // First process the file for preview
                    try {
                        let reader = new FileReader();

                        if (file.type.includes('image')) {
                            reader.onload = (e) => {
                                this.previewOrderImages.push({
                                    file_name: e.target.result,
                                    extension: file.type,
                                    file_type: 'image',
                                    uploaded: false // Mark as not uploaded yet
                                });
                                resolve(file);
                            };
                            reader.readAsDataURL(file);
                        } else if (file.type.includes('video')) {
                            reader.onload = (e) => {
                                const videoUrl = URL.createObjectURL(file);
                                this.previewOrderImages.push({
                                    file_name: videoUrl,
                                    extension: file.type,
                                    file_type: 'video',
                                    uploaded: false
                                });
                                resolve(file);
                            };
                            reader.readAsArrayBuffer(file);
                        } else if (file.type.includes('pdf')) {
                            const docUrl = URL.createObjectURL(file);
                            this.previewOrderImages.push({
                                file_name: docUrl,
                                extension: file.type,
                                file_type: 'pdf',
                                uploaded: false
                            });
                            resolve(file);
                        } else if(file.type.includes('msword') || file.type.includes('document')) {
                            const docUrl = URL.createObjectURL(file);
                            this.previewOrderImages.push({
                                file_name: docUrl,
                                extension: file.type,
                                file_type: 'document',
                                uploaded: false
                            });
                            resolve(file);
                        } else if (file.type === 'application/zip') {
                            this.previewOrderImages.push({
                                file_name: file.name,
                                extension: file.type,
                                file_type: 'zip',
                                uploaded: false
                            });
                            resolve(file);
                        }
                    } catch (error) {
                        reject(error);
                    }
                }).then(file => {
                    // After preview is created, upload the file
                    return this.uploadOrderImage({
                        file: file,
                        batch_id: batchId,
                        action: 'upload'
                    }).then(() => {
                        // Mark this file as uploaded in the preview
                        const previewIndex = this.previewOrderImages.findIndex(
                            img => img.file_name.includes(file.name) ||
                                (img.file_type === 'image' && !img.uploaded)
                        );
                        if (previewIndex !== -1) {
                            this.previewOrderImages[previewIndex].uploaded = true;
                        }
                        return true;
                    });
                });
            });

            // When all files are uploaded, trigger the final call
            Promise.all(uploadPromises)
                .then(() => {
                    return this.uploadOrderImage({
                        file: null,
                        batch_id: batchId,
                        action: 'generate_history'
                    });
                })
                .then(() => {
                    this.$notification('success', 'All files uploaded successfully');
                    this.updateOrderData.files = [];
                    this.previewOrderImages = [];
                    this.getOrderDetails();
                    this.processing = false;

                    // Reset selected files
                    $('#orderImage').val("");
                })
                .catch(error => {
                    console.error('Upload error:', error);
                    this.$notification('error', 'Some files failed to upload');
                });

            return;

            files.forEach((file, index) => {
                try {
                    let reader = new FileReader();
                    // Check the file type and adjust the processing accordingly
                    if (file.type.includes('image')) {
                        // Handle images
                        reader.onload = (e) => {
                            // Assuming `previewUploadedFiles` is meant to handle image previews
                            this.previewOrderImages.push({ file_name: e.target.result, extension: file.type, file_type: 'image', uploaded: true });
                        };
                        reader.readAsDataURL(file);
                    } else if (file.type.includes('video')) {
                        // Handle videos
                        reader.onload = (e) => {
                            // Assuming you want to store videos differently or not show previews
                            // Videos can be previewed by creating a video URL
                            const videoUrl = URL.createObjectURL(file);
                            // Assuming `previewUploadedFiles` is an array for storing video data
                            this.previewOrderImages.push({ file_name: videoUrl, extension: file.type, file_type: 'video' });
                        };
                        reader.readAsArrayBuffer(file); // We read videos as buffer since we don't need to display it as base64
                    } else if (file.type.includes('pdf')) {
                        // Handle PDFs and Documents
                        const docUrl = URL.createObjectURL(file);
                        this.previewOrderImages.push({ file_name: docUrl, extension: file.type, file_type: 'pdf' });
                    } else if(file.type.includes('msword') || file.type.includes('document')) {
                        const docUrl = URL.createObjectURL(file);
                        this.previewOrderImages.push({ file_name: docUrl, extension: file.type, file_type: 'document' });
                    } else if (file.type === 'application/zip') {
                        // Handle ZIP files
                        this.previewOrderImages.push({ file_name: file.name, extension: file.type, file_type: 'zip' });
                    }

                    this.updateOrderData.files.push(file);
                    this.uploadOrderImage(file, batchId, (index === totalFiles - 1));
                } catch (error) {
                    // Handle error
                }
            });

            return;

            for (let file of event.target.files) {
                try {
                    let reader = new FileReader();
                    // Check the file type and adjust the processing accordingly
                    if (file.type.includes('image')) {
                        // Handle images
                        reader.onload = (e) => {
                            // Assuming `previewUploadedFiles` is meant to handle image previews
                            this.previewOrderImages.push({ file_name: e.target.result, extension: file.type, file_type: 'image', uploaded: true });
                        };
                        reader.readAsDataURL(file);
                    } else if (file.type.includes('video')) {
                        // Handle videos
                        reader.onload = (e) => {
                            // Assuming you want to store videos differently or not show previews
                            // Videos can be previewed by creating a video URL
                            const videoUrl = URL.createObjectURL(file);
                            // Assuming `previewUploadedFiles` is an array for storing video data
                            this.previewOrderImages.push({ file_name: videoUrl, extension: file.type, file_type: 'video' });
                        };
                        reader.readAsArrayBuffer(file); // We read videos as buffer since we don't need to display it as base64
                    } else if (file.type.includes('pdf')) {
                        // Handle PDFs and Documents
                        const docUrl = URL.createObjectURL(file);
                        this.previewOrderImages.push({ file_name: docUrl, extension: file.type, file_type: 'pdf' });
                    } else if(file.type.includes('msword') || file.type.includes('document')) {
                        const docUrl = URL.createObjectURL(file);
                        this.previewOrderImages.push({ file_name: docUrl, extension: file.type, file_type: 'document' });
                    } else if (file.type === 'application/zip') {
                        // Handle ZIP files
                        this.previewOrderImages.push({ file_name: file.name, extension: file.type, file_type: 'zip' });
                    }

                    this.updateOrderData.files.push(file);
                    this.uploadOrderImage(file);
                } catch {}
            }
        },
        updateOrder() {
            let self = this;
            this.processing = true;
            const config = {
                headers: { "content-type": "multipart/form-data" },
            };
            axios.post('/handyman/orders/update/' + this.updateOrderData.orderId, this.updateOrderData, config)
                .then((response) => {
                    this.processing = false;
                    if (response.data.status === 'success') {
                        this.$notification('success', response.data.message);
                        self.previewOrderImages = [];
                        self.updateOrderData.comment = '';
                        self.updateOrderData.files = [];

                        $('#orderImage').val("");

                        // Fetch the order details
                        self.getOrderDetails();
                    }
                    else {
                        this.$notification('error', response.data.message);
                    }
                })
                .catch((error) => {
                    this.processing = false;
                    this.$notification('error', error.response.data.message);
                });
        },
        getClassByActionType(actionType) {
            switch (actionType) {
                case 'order_created':
                    return 'badge-success';
                case 'pending':
                    return 'badge-warning';
                case 'assigned':
                case 'assigned_to_handyman':
                    return 'badge-info';
                case 'processing':
                    return 'badge-primary';
                case 'quotation':
                    return 'badge-secondary';
                case 'status_reverted':
                    return 'badge-secondary';
                default:
                    return 'badge-light';
            }
        },
        formatDateTime(date, format) {
            return moment(date).format(format);
        },
        getImageUrl(filename) {
            // Assuming you have a base URL where images are stored
            const baseUrl = "https://example.com/path/to/images/";
            return `/uploads/order/${filename}`;
        },
        prepareImageSource(imgObj) {
            if (imgObj.file_type === 'image') {
                if (imgObj.uploaded) {
                    return imgObj.file_name;
                }
                else if (typeof imgObj.file_name !== 'undefined') {
                    return this.$s3RootUrl + "/order/" + imgObj.file_name;
                }
                else {
                    return this.$s3RootUrl + "/order/" + imgObj.image;
                }
            }
            else if(imgObj.file_type === 'video') {
                return this.$baseUrl + "/images/svg/file-video.svg";
            }
            else if(imgObj.file_type === 'zip') {
                return this.$baseUrl + "/images/svg/file-archive.svg";
            }
            else if(imgObj.file_type === 'pdf') {
                return this.$baseUrl + "/images/svg/file-pdf.svg";
            }
            else {
                return this.$baseUrl + "/images/svg/file-text.svg";
            }
        },
        attachImageSlider() {
            setTimeout(() => {
                // Slider for order images
                this.showSlider('.order-img-slides');

                // Slider for order history images
                this.showSlider('.order-history-img-slides');

            }, 3000)
        },
        showSlider(selector) {
            GLightbox({
                selector: selector,
                touchNavigation: true,
                loop: false,
                autoplayVideos: true
            });
        },
        async copyToClipboard(textToCopy) {
            try {
                await navigator.clipboard.writeText(textToCopy);
                this.$notification('success', 'Copied to clipboard');
            } catch (error) {
                this.$notification('error', 'Failed to copy to clipboard');
            }
        },
        updateTaskStatus() {
            $('#markOrderCompletedModal').modal('show');
            return;
        },
        scrollToSection(sectionId) {
            const element = document.getElementById(sectionId);
            if (element) {
                const offset = 80; // Adjust for sticky header height
                const bodyRect = document.body.getBoundingClientRect().top;
                const elementRect = element.getBoundingClientRect().top;
                const elementPosition = elementRect - bodyRect;
                const offsetPosition = elementPosition - offset;

                window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth'
                });
            }
        },
        markCompleted() {
            if (!this.isOrderCompleted) {
                this.order.status = 'engineer_completed';
                this.isCompleted = true;  // Update the toggle state
                // Prepare comment
                let comment = this.completedOrder.comment.trim() || '';

                // Check if comment is not empty
                if (comment.length > 0) {
                    comment = comment + ` - Order marked as completed by ${this.user.name}`;
                }
                else {
                    comment = `Order marked as completed by ${this.user.name}`;
                }

                this.processing = true;

                // Update the order status
                axios.post('/handyman/orders/mark-completed/' + this.order.id, {
                    status: 'engineer_completed',
                    comment: comment,
                    files: this.completedOrder.files,
                    revisit_or_complete: this.completedOrder.revisitOrComplete
                }, {
                    headers: { "content-type": "multipart/form-data" },
                })
                    .then((response) => {
                        if (response.data.status === 'success') {
                            this.$notification('success', response.data.message);
                        }
                        else {
                            this.$notification('error', response.data.message);
                            this.isCompleted = false;  // Update the toggle state
                        }
                        this.getOrderDetails();

                        // hide the modal
                        $("#markOrderCompletedModal").modal("hide");
                    })
                    .catch((error) => {
                        this.$notification('error', error.response.data.message);
                        this.isCompleted = false;  // Update the toggle state
                    })
                    .finally(() => {
                        this.processing = false;
                    });
            }
            else {
                this.order.status = this.orderStatus;
                this.isCompleted = false;  // Update the toggle state
            }
        },
        selectTaskImage(event) {
            for (let file of event.target.files) {
                try {
                    let reader = new FileReader();
                    // Check the file type and adjust the processing accordingly
                    if (file.type.includes('image')) {
                        // Handle images
                        reader.onload = (e) => {
                            this.completedOrder.images.push({ file_name: e.target.result, extension: file.type, file_type: 'image', uploaded: true });
                        };
                        reader.readAsDataURL(file);
                    }

                    this.completedOrder.files.push(file);
                } catch {}
            }
        },
        uploadOrderImage(params) {
            return new Promise((resolve, reject) => {
                const config = {
                    headers: { "content-type": "multipart/form-data" },
                };

                // Prepare post data
                let postData = new FormData();
                postData.append('order_id', this.order.id);
                postData.append('batch_id', params.batch_id || '');
                postData.append('action', params.action || 'upload');

                if (params.file) {
                    postData.append('file', params.file);
                }

                axios.post('/api/handyman/upload-order-image', postData, config)
                    .then((response) => {
                        if (response.data.status === 'success') {
                            resolve(response.data);
                        } else {
                            reject(response.data.message);
                        }
                    })
                    .catch((error) => {
                        reject(error.response.data.message);
                    });
            });
        },
        handleUploadsCompleted(uploadedFiles) {
            this.getOrderDetails();
        }
    },
    watch: {
        'order.status': {
            immediate: true,
            handler(newStatus) {
                this.isCompleted = ['completed', 'cancelled', 'rejected', 'engineer_completed'].includes(newStatus);
            }
        }
    }
}
</script>
